import {getLayerNamePrefix, setVisibleByLayerName, updateLayerSourceParams} from "@/helpers/ol/ol-layer-helper";
import {getPresentationCategory} from "@/http/services/http-services-presentation-category";
import {updateWfsStyle} from "@/helpers/ol/wfs/wfs-style-helper";
import {
    or as orFilter,
    equalTo as equalToFilter,
    like as likeFilter,
} from 'ol/format/filter.js';
import * as olXml from 'ol/xml';
import {parse} from "ol/xml";
import XML from "ol/format/XML";
import {getKVLayerByBookmarkPresentationID} from "@/helpers/kv/kv-layer-helper";
import {getBySelector} from "@/helpers/element-helper";
import {initContextMenuDomainList} from "@/helpers/context-menu-helper";
import {reloadServiceClick} from "@/helpers/ol/ol-http-helper";
import {clearInfo} from "@/helpers/layer/info/layer-info-info-helper";
import {getOgcInFilter} from "@/helpers/filter/filter-ogc-helper";
import {clickMap} from "@/helpers/ol/ol-map-helper.js";
import ca from "datatables.net-plugins/i18n/ca.mjs";

export function hasLayerDomainList(bookmarkPresentation) {
    return Array.isArray(bookmarkPresentation.WfsStyle.styles)
}

export function loadLayerOverViewDomainList(bookmarkPresentation, element) {


    if(hasLayerDomainList(bookmarkPresentation)) {
        if(element) {
            element.querySelector('layer-menu-button-check').classList.remove('d-none')
        }

        if(!bookmarkPresentation.WfsStyle.styles[0] || !bookmarkPresentation.WfsStyle.styles[0].Name) {
            if(bookmarkPresentation.WfsStyle.attribute !== null) {
                getPresentationCategory(bookmarkPresentation.BookmarkPresentationID).then((result) => {
                    generateLayerOverViewDomainList(result.Attribute, result.domain_list_items, bookmarkPresentation, result)
                })
            }
        } else {
            generateLayerOverViewDomainList(bookmarkPresentation.WfsStyle.attribute, bookmarkPresentation.WfsStyle.styles, bookmarkPresentation)
        }
    } else {
        if(element) {
            element.querySelector('layer-menu-button-check').classList.add('d-none')
        }
    }
}

export function generateLayerOverViewDomainList(attribute, domainListItems, bookmarkPresentation, domainList) {

    let innerHTML = ``
    innerHTML += `
                <div class="mb-1 ml-4 layer-over-view-domain-list">`

    domainListItems = domainListItems.filter(style => style.Name !== '')
    domainListItems.map(style => {

        let name = style.Name
        if(name === '') {
            name = 'Lege waarde'
        }

        if(bookmarkPresentation.WfsStyle.styles.length === 1) {
            style.style_settings = bookmarkPresentation.WfsStyle.styles[0].style_settings
        }

        let checked = 'checked="checked"'
        if(style.Active === 0 || domainList?.Active === 0) {
            checked = ''
        }

        console.log(domainList)

        if(bookmarkPresentation.Type === '3DTileSet') {
            innerHTML +=
                `<div class="form-group">
                                        <span class="label">`

                innerHTML += `<span class="fa fa-square mr-2" style="color: ` + style.style_settings.fillColor + `"></span>`

            innerHTML += name + `</span>
                </label>
              </div>`
        } else {
            innerHTML +=
                `<div class="form-group">
                    <label class="custom-control custom-checkbox">
                      <input type="checkbox" value="` + style.Value + `" class="custom-control-input layer-over-view-domain-list-checkbox" ` + checked + `>
                      <span class="custom-control-label">`


            if(style.style_settings.fillColor && (bookmarkPresentation.Type === 'WFS' || (window.settings.wfsStyle.fillColor !== style.style_settings.fillColor))) {
                innerHTML += `<span class="fa fa-square mr-2" style="color: ` + style.style_settings.fillColor + `"></span>`
            } else if(!style.style_settings.fillColor && bookmarkPresentation.Type === 'WFS') {
                innerHTML += `<span class="fa fa-square mr-2" style="color: ` + window.settings.wfsStyle.fillColor + `"></span>`
            }

            innerHTML += name + `</span>`
            if(style.Count) {
                innerHTML += `<div class="layer-menu-button mr-2">${style.Count}</div>`
            }

            innerHTML += `
                </label>
              </div>`
        }
    })

    innerHTML += `</div>`

    let domainListElements = []
    let updateCategories = false
    document.querySelectorAll('layer-menu-group-item').forEach(element => {
        if (
            !element.querySelector('.layer-over-view-domain-list') &&
            (
                parseInt(element.dataset.id) === bookmarkPresentation.ID ||
                parseInt(element.dataset.bookmarkPresentationId) === bookmarkPresentation.ID
            )
        ) {
            if(element.dataset.id) {
                updateCategories = true
            }

            domainListElements.push(element)
            element.children[0].insertAdjacentHTML('beforeend', innerHTML);
            initContextMenuDomainList(element)
        }
    })

    console.log(bookmarkPresentation.ID)
    const merged = getBySelector(`layer-menu-group-merged[data-depth="${bookmarkPresentation.ID}"]`)
    if(merged) {
        innerHTML = innerHTML.replace('ml-4', 'ml-5')

        let mergedDomainList = merged.parentElement.querySelector('.layer-over-view-domain-list')


        if(!merged.parentElement.children[1].classList.contains('layer-over-view-domain-list')) {
            merged.insertAdjacentHTML('afterend', innerHTML)
            domainListElements = []
            domainListElements.push(merged.parentElement.querySelector('.layer-over-view-domain-list'))
        } else {
            mergedDomainList.classList.remove('d-none')
        }
    }

    domainListElements.map((domainListElement) => {
        const toggleAll = domainListElement.querySelector('.layer-over-view-domain-list-toggle-all')
        if(toggleAll) {
            toggleAll.addEventListener('click', (element) => {
                //// console.log(element)
                const closest = element.srcElement.closest('.layer-over-view-domain-list')

                let checked
                closest.querySelectorAll('.layer-over-view-domain-list-checkbox').forEach((element, index) => {

                    if(index === 0) {
                        checked = !element.checked
                    }
                    element.checked = checked

                    element.dispatchEvent(new Event('click'));
                })
            })
        }

        let wmsCategories = []
        let categories = []

        domainListElement.querySelectorAll('.layer-over-view-domain-list-checkbox').forEach(element => {

            wmsCategories = []
            categories = []

            element.closest('.layer-over-view-domain-list').querySelectorAll('.layer-over-view-domain-list-checkbox').forEach((element) => {
                if (element.checked) {
                    wmsCategories.push("'" + element.value + "'")
                    categories.push(element.value)
                }
            })

            console.log(element)
            console.log(wmsCategories)
            console.log(attribute)

            element.addEventListener('click', (e) => {

                console.log('clickk')

                wmsCategories = []
                categories = []

                console.log(element)

                element.closest('.layer-over-view-domain-list').querySelectorAll('.layer-over-view-domain-list-checkbox').forEach((element) => {
                    if (element.checked) {
                        wmsCategories.push("'" + element.value + "'")
                        categories.push(element.value)
                    }
                })

                console.log(wmsCategories)

                updateLayerSource(bookmarkPresentation, wmsCategories, attribute, categories)

                const value = e.target.value
                const checked = e.target.checked

                const elements = document.querySelectorAll('layer-menu-group-item[data-id="' + bookmarkPresentation.id + '"], layer-menu-active-item[data-id="' + bookmarkPresentation.id + '"]')
                elements.forEach(element => {
                    const checkbox = element.querySelector('input[type="checkbox"][value="' + value + '"]')
                    if(checkbox) {
                        checkbox.checked = checked
                    }
                })

                if(window.clickMapPixel && !checked) {
                    console.log('clickkk')
                    setTimeout(() => {

                        clickMap(window.clickMapPixel, window.clickMapCoordinate)
                    }, 0)
                }
            });
        });

        if(updateCategories) {
            updateLayerSource(bookmarkPresentation, wmsCategories, attribute, categories)
        }
    })
}

export function showHideLayerOverViewDomainList(bookmarkPresentationID, visible) {

    let layerElement

    const merged = getBySelector(`layer-menu-group-merged[data-depth="${bookmarkPresentationID}"]`)
    if(merged) {
        merged.parentElement.querySelector('.layer-over-view-domain-list')?.classList.add('d-none')
    }

    document.querySelectorAll('layer-menu-group-item').forEach(element => {
        if (parseInt(element.dataset.id) === parseInt(bookmarkPresentationID)) {
            layerElement = element
        }
    })

    if(layerElement) {
        const list = layerElement.querySelector('.layer-over-view-domain-list')

        if (list) {
            if (visible) {
                list.classList.remove('d-none')
            } else {
                list.classList.add('d-none')
            }
        }
    }
}

function updateLayerSource(bookmarkPresentation, wmsCategories, attribute, categories) {

    const value = attribute + ' in (' + wmsCategories.join(', ') + ')'
    if(bookmarkPresentation.Type === 'WMS') {
        if(wmsCategories.length === 0) {
            setVisibleByLayerName(getLayerNamePrefix() + bookmarkPresentation.ID, false)
        } else {
            setVisibleByLayerName(getLayerNamePrefix() + bookmarkPresentation.ID, true)

            if(bookmarkPresentation.Filter.Filter && bookmarkPresentation.Service.Proxy === 0) {
                const ogcInFilter = getOgcInFilter(bookmarkPresentation.BookmarkPresentationID, bookmarkPresentation.WfsStyle.attribute, bookmarkPresentation.Filter.Filter)
                updateLayerSourceParams(bookmarkPresentation.ID, 'FILTER', ogcInFilter)
            } else {
                updateLayerSourceParams(bookmarkPresentation.ID, 'CQL_FILTER', value)
            }
        }
    } else if(bookmarkPresentation.Type === 'WFS') {
        // console.log('update wfs style')
        //// console.log(categories)
        const kvLayer = getKVLayerByBookmarkPresentationID(bookmarkPresentation.ID)
        kvLayer.CQL_FILTER = value
        updateWfsStyle(bookmarkPresentation, attribute, categories)
    }

    if(window.result) {
        const mainTab = window.result.mainTabs.find(mainTab => mainTab.BookmarkPresentationID === bookmarkPresentation.ID)
        if(mainTab && mainTab.features.length > 0) {
            window.result.mainTabs[0].features[0].featureInfo[0].records[0].attributes.map((recordAttribute) => {
                recordAttribute.map(attributeItem => {

                    if(attributeItem.Attribute === attribute) {

                        if(!categories.includes(attributeItem.Value)) {
                            clearInfo()
                        }
                    }
                })
            })
        }
    }
}

export function getActiveValuesByBookmarkPresentationID(bookmarkPresentationID) {
    let values = []
    const layerMenuActive = getBySelector('layer-menu-overview')

    if(layerMenuActive) {
        layerMenuActive.querySelector('layer-menu-group-item[data-id="' + bookmarkPresentationID + '"]').querySelectorAll('.layer-over-view-domain-list input:checked').forEach(element => {
            values.push(element.value)
        })
    }
    return values
}

export function getDomainListItemsByBookmarkPresentationID(id) {
    const element = getBySelector(`layer-menu-group-item[data-id="${id}"]`)
    let hasCategoryButEmpty = true

    if(element) {
        if(!element.querySelector('.layer-over-view-domain-list-checkbox')) {
            return null
        }
        element.querySelectorAll('.layer-over-view-domain-list-checkbox').forEach((element) => {
            if (element.checked) {
                hasCategoryButEmpty = false
            }
        })
    } else {
        return null
    }

    return hasCategoryButEmpty
}
